var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.displayBar)?_c('v-app-bar',{attrs:{"app":"","color":_vm.color,"dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.title))])],1):_vm._e(),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }